(ns manage.product-ocp.view
  (:require ["@mui/material/Button$default" :as Button]
            ["react-hook-form" :as rhf]
            [cljs-bean.core :refer [->clj]]
            [clojure.string :as str]
            [common.form :as form]
            [common.ocp.view :refer [defocp ocp]]
            [common.util :refer [spread-obj]]
            [common.widgets.asset-upload :as upload]
            [common.widgets.form-field :refer [form-field]]
            [manage.product-ocp.hooks :as hooks]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui ocp-footer
  [{:keys [mode product-id on-delete ^js formState]}]
  (let [edit-allowed? (use-subscribe [:resource.user/allowed? "products.edit"])
        is-submitting (.-isSubmitting formState)]
    ($ :<>
       (when (and (= mode :edit) product-id)
         ($ Button
            {:variant "contained"
             :color "error"
             :on-click on-delete
             :disabled (or (not edit-allowed?) is-submitting)
             :data-testid "ocp-delete-product-button"}
            "Delete Product"))
       ($ Button
          {:type "submit"
           :variant "contained"
           :disabled (or (not edit-allowed?) is-submitting)
           :data-testid (if (= mode :edit) "ocp-update-product-button" "ocp-create-product-button")}
          (if (= mode :edit) "Update Product" "Create Product")))))

(defui field-input-number
  [{:keys [name control ^js controller-props]}]
  ($ form/form-text-field
     {:name name
      :on-change-fn (fn [raw-value]
                      (let [normalized (when raw-value
                                         (str/replace raw-value #"," "."))
                            parsed (js/parseFloat normalized)]
                        (if (or (js/isNaN parsed) (str/ends-with? normalized "."))
                          raw-value
                          parsed)))
      :controller-props (spread-obj #js {:step "any"
                                         :type "number"}
                                    controller-props)
      :control control}))

(defui field-input-image-url
  [{:keys [name control ^js controller-props]}]
  ($ rhf/Controller
     {:name name
      :control control
      :render (fn [^js props]
                (let [{{:keys [onChange value]} :field} (->clj props)]
                  (if (.-disabled controller-props)
                    ;; Read-only view
                    ($ :img.image-preview__img
                       {:alt "Image is missing"
                        :src value})
                    ;; Upload widget
                    ($ upload/upload
                       {:value value
                        :onChange onChange
                        :maxSize (* 5 1000 1000)
                        :on-clear #(onChange nil)
                        :extensions ".jpg, .png, .gif, .svg"
                        :filetype "image"}))))}))

;; Dynamic field component
(defui field
  [{:keys [name type control disabled]}]
  (let [field-input-component (case type
                                "date-time" form/form-date-time-picker
                                "number" field-input-number
                                "boolean" form/checkbox
                                "image-url" field-input-image-url
                                form/form-text-field)]
    ($ form-field
       {:label name}
       ($ field-input-component
          {:name (str "fields." name)
           :control control
           :controller-props #js {:disabled disabled}}))))

(defocp product-ocp :product/crud [{:keys [product]}]
  (let [{:keys [form-control on-submit on-delete product-store-fields mode loading]}
        (hooks/use-product-form product)

        {:keys [control formState]} form-control

        edit-allowed? (use-subscribe [:resource.user/allowed? "products.edit"])]

    ($ ocp
       {:title (if (= mode :edit) "Edit Product" "Add a new Product")
        :footer ($ ocp-footer
                   {:mode mode
                    :product-id (:id product)
                    :on-delete on-delete
                    :formState formState})
        :on-submit on-submit}

       ;; SKU Field (required, immutable in edit mode)
       ($ form-field
          {:label "SKU"}
          ($ form/form-text-field
             {:name "sku"
              :controller-props #js {:disabled (= :edit mode)}
              :control control}))

       ;; Dynamic fields from product store
       (when-not loading
         (for [{:keys [id name type]} product-store-fields]
           ($ field
              {:key id
               :name name
               :type type
               :control control
               :disabled (not edit-allowed?)}))))))
